<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dammit-white-dog">
<h1>2-Dammit White Dog</h1>
<p>Many moons ago, we would announce when a doggie-client left the salon. We don’t do that anymore; this pup could be part of the reason why. We would page over the intercom to advertise the freshly groomed pet to bring more business into the salon.</p>
<p>“Thank you, Fluffy, for coming to the salon today!”</p>
<p>“Fluffy looks great leaving the grooming salon after his bath; book yours today!”</p>
<p>Ms. Perkins, a petite, well-dressed, mature, and polite African American woman, came in. She’d never been to the salon before and was dropping her dog off. She wanted to wait for him since they rescued him from the streets and this was his first groom.</p>
<p>We went through the standard health questions to check vaccinations and health records. Then we started to input the information into the database.</p>
<p>“We just need to put in the basic info.” I inform her. I go through all the basics. “Your name, breed of dog, age, color, and dog’s name?”</p>
<p>“Bettie Perkins. Lab mix, about four years, white, male…”</p>
<p>“And what’s the baby’s name?” I ask again.</p>
<p>“Can we leave it blank?” Ms. Perkins asks.</p>
<p>Confused, I answer, “Not really; we have to have a name for him.”</p>
<p>Mumbled and under her breath, Ms. Perkins says, “Duuu, Whaaa Dog.” Is all I heard.</p>
<p>“I’m sorry, what was the name?” Sure I’d misheard.</p>
<p>“Okay, so promise you won’t judge me.” She begs, leaning forward and clutching her dainty Prada bag.</p>
<p>“Absolutely. Ma’am, we’ve heard it all.” Or…so I thought.</p>
<p>“His name is a little different. We found him. We rescued him…”</p>
<p>I was pleased to hear that this baby was rescued from the streets of Houston and taken in by a nice family.</p>
<p>“So, we found him, he was in the rain, and we didn’t want to take him to the shelter. But we couldn’t decide on a name.”</p>
<p>I nod. Some people wait to give a name that fits a pup’s personality.</p>
<p>“We love him, but he kept getting into stuff; I mean, it was a brand-new environment, new people, and place, so he was just testing his boundaries…and we’re not racist. Not at all. I swear!”</p>
<p>I keep nodding. Now I’m starting to get nervous. Where is this story going? Nothing good ever comes from the statement ‘I’m not racist’ I think to myself. I keep nodding hoping my ‘customer service smile’ hasn’t worn off.</p>
<p>“Whenever he would get into the trash or dig, we still hadn’t named him, and our family is big, so we couldn’t decide, so everyone just called him what he was.” She pauses here and looks at the floor as if she’s about to be punished. “We would just yell out ‘Dammit, White Dog!’ But please, I swear we’re not racist or trying to be rude.”</p>
<p>Chuckles, chortles, snorting; we try to suppress our giggles. Then all-out laughter ensues. “It’s a great name. No one will ever have his name.” I tell her. “I thought I’d heard it all. I can guarantee we won’t ever have another dog with his name.”</p>
<p>“Oh, this is embarrassing.” Ms. Perkins says, putting her hands over her face.</p>
<p>Everyone in the salon reassures her. He was the most popular dog that day, that week, and that year.</p>
<p>Dammit White Dog was a regular client for years. He and Ms. Perkins were sweet and didn’t give anyone any trouble.</p>
<p>We brushed him, cleaned his ears, and filed his nails each time he came in.</p>
<p>It will remain a highlight of my career to have heard, “Thank you, Dammit White Dog, for coming to the salon for your bath today!”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?61fcfd2e